/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FilterType {
  Equals = 'Equals',
  NotEquals = 'NotEquals',
  In = 'In',
  NotIn = 'NotIn',
  GreaterThan = 'GreaterThan',
  GreaterOrEqualThan = 'GreaterOrEqualThan',
  LessThan = 'LessThan',
  LessOrEqualThan = 'LessOrEqualThan'
}
